import { render } from "./index.vue?vue&type=template&id=518d4ce2"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/customer_products/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "518d4ce2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('518d4ce2', __exports__)) {
    console.log('reload')
    api.reload('518d4ce2', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=518d4ce2", () => {
    console.log('re-render')
    api.rerender('518d4ce2', render)
  })

}


export default __exports__